import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "./api";
import { LogoMark, Wordmark } from "../site/Logo";

const inputCls = "mt-2 w-full rounded-xl border-2 border-black bg-white px-4 py-3 text-base text-black outline-none focus:shadow-[0_0_0_4px_rgba(0,0,0,0.12)]";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#E4E4E4] px-5 py-16">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-[28px] border-2 border-black bg-[#F2F2F2] p-8 shadow-[8px_8px_0_#000]">
        <div className="flex items-center gap-3">
          <LogoMark className="h-14 w-14" />
          <Wordmark className="h-14" fg="#111111" knock="#F2F2F2" />
        </div>
        <h1 className="mt-8 flex items-center gap-2 font-display text-3xl font-black text-black"><Lock className="h-6 w-6" /> Staff login</h1>
        <p className="mt-2 text-sm text-neutral-700">Sign in to review service provider applications.</p>
        <label className="mt-6 block text-sm font-semibold text-black">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className={inputCls} />
        </label>
        <label className="mt-4 block text-sm font-semibold text-black">Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className={inputCls} />
        </label>
        {error && <p className="mt-4 rounded-lg bg-black px-4 py-2 text-sm text-white" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-black py-4 font-display text-base font-bold text-[#E4E4E4] transition-transform duration-300 hover:scale-[1.02] disabled:opacity-70">
          {loading && <Loader2 className="h-5 w-5 animate-spin" />} Sign in
        </button>
        <a href="/" data-testid="admin-back-to-site" className="mt-5 block text-center text-sm font-semibold text-neutral-700 underline underline-offset-4 hover:text-black">Back to website</a>
      </form>
    </div>
  );
};
